import { useGetLoyaltyCard } from '@/api/react-query'
import { ApiError } from '@/api/api'
import { tenant } from '@/tenants/tenant'
import { detectWalletPlatform, selectWalletUrl } from '@/utils/wallet-url'

export type WalletUrlResult = {
	url: string | undefined
	isLoading: boolean
	/** True when the API confirmed the customer has no loyalty card (404) */
	notFound: boolean
}

export function useGetWalletUrl(enabled = true): WalletUrlResult {
	const { features } = tenant
	const loyaltyCard = useGetLoyaltyCard({ enabled: features.loyaltyCardEnabled && enabled })

	const notFound = loyaltyCard.error instanceof ApiError && loyaltyCard.error.httpStatusCode === 404

	if (!loyaltyCard.data?.walletLink) {
		return { url: undefined, isLoading: loyaltyCard.isLoading, notFound }
	}

	const platform = detectWalletPlatform()
	const url = selectWalletUrl(platform, loyaltyCard.data.walletLink)

	return { url, isLoading: loyaltyCard.isLoading, notFound }
}
